import { createFileRoute } from '@tanstack/react-router'
import { TeamProfileResearchRouteKernel, teamProfileResearchRouteKernel } from '~/features/research-workspace/route-kernels'

export const Route = createFileRoute('/research/teams/$team')({
  ...teamProfileResearchRouteKernel,
  component: TeamProfileResearchRoute,
})

function TeamProfileResearchRoute() {
  return <TeamProfileResearchRouteKernel route={Route} />
}
